export default "__VITE_ASSET__DYmmycVK__"